// extracted by mini-css-extract-plugin
module.exports = {"container":"SideBar_container__3UZi9","wrapper":"SideBar_wrapper__2nWzj","searchIcon":"SideBar_searchIcon__3cPZv"};